const STATS = [
  { value: '30,000+', label: '漫画作品' },
  { value: '500+', label: '每日更新' },
  { value: '800万+', label: '累计读者' },
];

export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-foreground-950"
    >
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20stylized%20manga%20comic%20inspired%20abstract%20background%20with%20warm%20orange%20red%20coral%20gradients%2C%20geometric%20panel%20layouts%2C%20japanese%20pop%20art%20aesthetic%2C%20dynamic%20energy%20waves%2C%20dark%20rich%20texture%2C%20cinematic%20atmosphere%2C%20no%20text%2C%20no%20characters%2C%20abstract%20composition%20with%20bold%20color%20blocks%20and%20subtle%20grid%20patterns%20reminiscent%20of%20comic%20pages&width=1600&height=900&seq=hero-bg-manga&orientation=landscape"
        alt="土豪漫画背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/65"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-[1440px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="flex flex-wrap justify-center lg:justify-start gap-2 mb-5">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium">
                <i className="ri-fire-line text-sm w-4 h-4 flex items-center justify-center"></i> 每日更新
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium">
                <i className="ri-book-open-line text-sm w-4 h-4 flex items-center justify-center"></i> 海量漫画
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50/20 text-white text-xs font-medium backdrop-blur-sm">
                <i className="ri-vip-crown-line text-sm w-4 h-4 flex items-center justify-center"></i> 完全免费
              </span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-3">
              土豪漫画网
              <span className="block text-xl sm:text-2xl md:text-3xl lg:text-4xl font-body font-light mt-2 text-white/80">
                韩漫日漫国漫，一站式免费在线阅读
              </span>
            </h1>

            <p className="text-sm sm:text-base text-white/70 leading-relaxed max-w-2xl mx-auto lg:mx-0 mt-5 mb-3">
              土豪漫画网汇聚海量韩漫、日漫、国漫资源，涵盖热血、恋爱、悬疑、搞笑等全部类型。无论你喜欢连载中的热门漫画还是经典完结作品，这里都能满足你。
            </p>
            <p className="text-sm sm:text-base text-white/70 leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-6">
              每日同步更新最新话，下拉式流畅阅读体验，无需等待加载。全站免费，无广告干扰，用最快的速度看最火的漫画。
            </p>

            <div className="flex flex-wrap justify-center lg:justify-start gap-6 md:gap-10 mb-7">
              {STATS.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading text-accent-400">{s.value}</div>
                  <div className="text-xs text-white/60 mt-1">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-3">
              <a
                href="#topics"
                onClick={(e) => { e.preventDefault(); scrollTo('#topics'); }}
                className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-full whitespace-nowrap transition-all cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg w-5 h-5 flex items-center justify-center"></i>
                开始阅读
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); scrollTo('#ranking'); }}
                className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-white/10 hover:bg-white/20 text-white font-medium text-sm rounded-full whitespace-nowrap transition-all cursor-pointer backdrop-blur-sm border border-white/20"
              >
                <i className="ri-bar-chart-line text-lg w-5 h-5 flex items-center justify-center"></i>
                热门排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[540px]">
            <img
              src="https://readdy.ai/api/search-image?query=Vibrant%20anime%20style%20manga%20reading%20on%20tablet%20device%20with%20colorful%20comic%20panel%20illustrations%20floating%20around%2C%20warm%20orange%20and%20coral%20accents%2C%20japanese%20pop%20culture%20aesthetic%2C%20dynamic%20composition%2C%20soft%20glowing%20edges%2C%20modern%20digital%20art%20style%2C%20energetic%20and%20exciting%20atmosphere%2C%20clean%20background%20with%20gradient&width=1080&height=1350&seq=hero-manga-visual&orientation=portrait"
              alt="土豪漫画在线阅读体验"
              className="w-full h-auto rounded-2xl object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}